import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppService } from './app.service';
import { environment } from '../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private appService: AppService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if (request.url === `${environment.serviceUrl}/uaa/oauth/token`) {
      let clonedRequest = request.clone({
        setHeaders: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': '*',
          'Access-Control-Allow-Headers': '*'
        }
      });
      return next.handle(clonedRequest);
    } else {
      const observable = new Observable<HttpEvent<unknown>>((observer) => {
        this.appService.retrieveToken().subscribe((data: { access_token }) => {
          this.appService.setToken(data.access_token);
          const clonedRequest = request.clone({
            setHeaders: {
              Authorization: `Bearer ${data.access_token}`
            }
          });
          next.handle(clonedRequest).subscribe(event => {
            observer.next(event);
          }, (error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.appService.setToken(null);
              this.appService.retrieveToken().subscribe((newToken: { access_token }) => {
                this.appService.setToken(newToken.access_token);
                const retryClonedRequest = request.clone({
                  setHeaders: {
                    Authorization: `Bearer ${newToken.access_token}`
                  }
                });
                next.handle(retryClonedRequest).subscribe(retryEvent => {
                  observer.next(retryEvent);
                }, (retryError: HttpErrorResponse) => {
                  observer.error(retryError);
                });
              });
            } else {
              observer.error(error);
            }
          });
        });
      });

      return observable;
    }
  }
}
